import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const splitwise = defineConnector({
  identifier: "splitwise",
  name: "Splitwise",
  tagLine: "Shared expense tracking",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://secure\\.splitwise\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Splitwise app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Splitwise Developer Portal](https://secure.splitwise.com/apps) and register a new application to get your consumer key and consumer secret.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/splitwise/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Splitwise account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Splitwise account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://secure.splitwise.com/oauth/authorize",
    tokenEndpoint: () => "https://secure.splitwise.com/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://secure.splitwise.com/api/v3.0/get_current_user",
  },
});
